import { PageId } from '@blcloud/bl-ng-share-module';

/**
 * 画面IDを表す列挙型
 */
export namespace PrintPageId {

  /** 在庫移動確認表_在庫移動確認表 */
  export const PmStockMoveConfirmation_Stock_0020 = PageId.PmStockMoveConfirmation + '-Pm-0';

  /** 在庫移動確認表_在庫移動確認表(集計) */
  export const PmStockMoveConfirmation_Stock_0021 = PageId.PmStockMoveConfirmation + '-Pm-1';

  /** 発注一覧表_発注一覧表 */
  export const PmOrderList_Purchase_0030 = PageId.PmOrderList + '-Pm-0';

  /** 発注一覧表_発注残一覧表 */
  export const PmOrderList_Purchase_0031 = PageId.PmOrderList + '-Pm-1';

  /** 車両別出荷実績表_車両別出荷実績表 */
  export const PmVehicleShipmentPerformanceList_Sales_0230 = PageId.PmVehicleShipmentPerformanceList + '-Pm-0';

  /** 車両別出荷実績表_車両別出荷部品リスト */
  export const PmVehicleShipmentPerformanceList_Sales_0231 = PageId.PmVehicleShipmentPerformanceList + '-Pm-1';

  /** 入庫予定表_入庫予定表(倉庫・棚番) */
  export const PmReceiptSchedule_Purchase_0020 = PageId.PmReceiptSchedule + '-Pm-0';

  /** 入庫予定表_入庫予定表(倉庫・品番) */
  export const PmReceiptSchedule_Purchase_0021 = PageId.PmReceiptSchedule + '-Pm-1';

  /** 入庫予定表_入庫予定表(倉庫・仕入先・品番) */
  export const PmReceiptSchedule_Purchase_0022 = PageId.PmReceiptSchedule + '-Pm-2';

  /** 入庫予定表_入庫予定表(倉庫・仕入先・伝票番号) */
  export const PmReceiptSchedule_Purchase_0023 = PageId.PmReceiptSchedule + '-Pm-3';

  /** 仕入確認表_仕入確認表(明細タイプ) */
  export const PmPurchaseConfirmationList_Purchase_0050 = PageId.PmPurchaseConfirmationList + '-Pm-0';

  /** 仕入確認表_仕入確認表(伝票タイプ) */
  export const PmPurchaseConfirmationList_Purchase_0051 = PageId.PmPurchaseConfirmationList + '-Pm-1';

  /** UOE送信前リスト_UOE発注前リスト(注文番号別) */
  export const PmUoeBeforeSendList_Purchase_0060 = PageId.PmUoeBeforeSendList + '-Pm-0';

  /** UOE送信前リスト_UOE発注前リスト(発注先別) */
  export const PmUoeBeforeSendList_Purchase_0061 = PageId.PmUoeBeforeSendList + '-Pm-1';

  /** 仕入日報月報_仕入日報月報(組織別) */
  export const PmPurchaseDailyReportMonthlyReport_Purchase_0080 = PageId.PmPurchaseDailyReportMonthlyReport + '-Pm-0';

  /** 仕入日報月報_仕入日報月報(仕入先別) */
  export const PmPurchaseDailyReportMonthlyReport_Purchase_0081 = PageId.PmPurchaseDailyReportMonthlyReport + '-Pm-1';

  /** 売上確認表_売上確認表(伝票タイプ) */
  export const PmSalesConfirmation_Sales_0270 = PageId.PmSalesConfirmation + '-Pm-0';

  /** 売上確認表_売上確認表(明細タイプ) */
  export const PmSalesConfirmation_Sales_0271 = PageId.PmSalesConfirmation + '-Pm-1';

  /** 受注・貸出確認表_受注確認表(合計) */
  export const PmOrderLoanConfirmation_Sales_0280 = PageId.PmOrderLoanConfirmation + '-Pm-00';

  /** 受注・貸出確認表_受注確認表(明細) */
  export const PmOrderLoanConfirmation_Sales_0281 = PageId.PmOrderLoanConfirmation + '-Pm-01';

  /** 受注・貸出確認表_貸出確認表(合計) */
  export const PmOrderLoanConfirmation_Sales_0282 = PageId.PmOrderLoanConfirmation + '-Pm-10';

  /** 受注・貸出確認表_貸出確認表(明細) */
  export const PmOrderLoanConfirmation_Sales_0283 = PageId.PmOrderLoanConfirmation + '-Pm-11';

  /** 返品理由分析表_返品理由分析表(返品理由別) */
  export const PmSalesMonthlyAnnualReport_Sales_0120 = PageId.PmSalesMonthlyAnnualReport + '-Pm-0';

  /** 返品理由分析表_返品理由分析表(得意先別) */
  export const PmSalesMonthlyAnnualReport_Sales_0121 = PageId.PmSalesMonthlyAnnualReport + '-Pm-1';

  /** 返品理由分析表_返品理由分析表(担当者別) */
  export const PmSalesMonthlyAnnualReport_Sales_0122 = PageId.PmSalesMonthlyAnnualReport + '-Pm-2';

  /** 返品理由分析表_返品理由分析表(受注者別) */
  export const PmSalesMonthlyAnnualReport_Sales_0123 = PageId.PmSalesMonthlyAnnualReport + '-Pm-3';

  /** 返品理由分析表_返品理由分析表(発行者別) */
  export const PmSalesMonthlyAnnualReport_Sales_0124 = PageId.PmSalesMonthlyAnnualReport + '-Pm-4';

  /** 出荷商品優良対応表_出荷商品優良対応表 */
  export const PmExcellentCorrespondListInfo_Sales_0260 = PageId.PmExcellentCorrespondListInfo + '-Pm-0';

  /** 出荷商品優良対応表_出荷商品優良対応表Ⅱ */
  export const PmExcellentCorrespondListInfo_Sales_0261 = PageId.PmExcellentCorrespondListInfo + '-Pm-1';

  /** 在庫未出荷一覧表_仕入先別在庫未出荷一覧表 */
  export const PmStockUnshippedList_Stock_0130 = PageId.PmStockUnshippedList + '-Pm-0';

  /** 在庫未出荷一覧表_棚番別在庫未出荷一覧表 */
  export const PmStockUnshippedList_Stock_0131 = PageId.PmStockUnshippedList + '-Pm-1';

  /** 在庫未出荷一覧表_BLコード別在庫未出荷一覧表 */
  export const PmStockUnshippedList_Stock_0132 = PageId.PmStockUnshippedList + '-Pm-4';

  /** 在庫看板印刷_在庫看板(5×9) 連帳 */
  export const PmStockSignPrint_Stock_0150 = PageId.PmStockSignPrint + '-Pm-0';

  /** 在庫看板印刷_在庫看板(3×9) 連帳 */
  export const PmStockSignPrint_Stock_0151 = PageId.PmStockSignPrint + '-Pm-1';

  /** 在庫看板印刷_在庫看板(3×9) A4 */
  export const PmStockSignPrint_Stock_0153 = PageId.PmStockSignPrint + '-Pm-2';

  /** 在庫看板印刷_在庫看板(4×11) A4 */
  export const PmStockSignPrint_Stock_0155 = PageId.PmStockSignPrint + '-Pm-3';

  /** 得意先過年度統計表_得意先過年度統計表(組織別) */
  export const PmCustomerPreviousStatisticsList_Sales_0130_1 = PageId.PmCustomerPreviousStatisticsList + '-Pm-1';

  /** 得意先過年度統計表_得意先過年度統計表(管理組織別) */
  export const PmCustomerPreviousStatisticsList_Sales_0130_2 = PageId.PmCustomerPreviousStatisticsList + '-Pm-3';

  /** 得意先過年度統計表_得意先過年度統計表(得意先別) */
  export const PmCustomerPreviousStatisticsList_Sales_0131_1 = PageId.PmCustomerPreviousStatisticsList + '-Pm-0';

  /** 得意先過年度統計表_得意先過年度統計表(請求先別) */
  export const PmCustomerPreviousStatisticsList_Sales_0131_2 = PageId.PmCustomerPreviousStatisticsList + '-Pm-4';

  /** 得意先過年度統計表_得意先過年度統計表(得意先組織別) */
  export const PmCustomerPreviousStatisticsList_Sales_0132 = PageId.PmCustomerPreviousStatisticsList + '-Pm-2';

  /** 得意先過年度統計表_得意先過年度統計表(担当者得意先別) */
  export const PmCustomerPreviousStatisticsList_Sales_0133 = PageId.PmCustomerPreviousStatisticsList + '-Pm-10';

  /** 売上日報月報_売上日報月報(得意先別)_全組織_得意先 */
  export const PmSalesReport_0_0_0 = PageId.PmSalesReport + '-Pm-000';

  /** 売上日報月報_売上日報月報(得意先別)_全組織_組織 */
  export const PmSalesReport_0_0_1 = PageId.PmSalesReport + '-Pm-001';

  /** 売上日報月報_売上日報月報(得意先別)_全組織_得意先 - 組織 */
  export const PmSalesReport_0_0_2 = PageId.PmSalesReport + '-Pm-002';

  /** 売上日報月報_売上日報月報(得意先別)_全組織_管理組織 */
  export const PmSalesReport_0_0_3 = PageId.PmSalesReport + '-Pm-003';

  /** 売上日報月報_売上日報月報(得意先別)_組織毎_得意先 */
  export const PmSalesReport_0_1_0 = PageId.PmSalesReport + '-Pm-010';

  /** 売上日報月報_売上日報月報(得意先別)_組織毎_得意先 */
  export const PmSalesReport_0_1_1 = PageId.PmSalesReport + '-Pm-001';

  /** 売上日報月報_売上日報月報(得意先別)_組織毎_得意先 */
  export const PmSalesReport_0_1_2 = PageId.PmSalesReport + '-Pm-012';

  /** 売上日報月報_売上日報月報(得意先別)_組織毎_得意先 */
  export const PmSalesReport_0_1_3 = PageId.PmSalesReport + '-Pm-013';

  /** 売上日報月報_売上日報月報(担当者別)_全組織_担当者 */
  export const PmSalesReport_1_0_0 = PageId.PmSalesReport + '-Pm-100';

  /** 売上日報月報_売上日報月報(担当者別)_全組織_得意先 */
  export const PmSalesReport_1_0_1 = PageId.PmSalesReport + '-Pm-101';

  /** 売上日報月報_売上日報月報(担当者別)_全組織_担当者 - 組織 */
  export const PmSalesReport_1_0_2 = PageId.PmSalesReport + '-Pm-102';

  /** 売上日報月報_売上日報月報(担当者別)_全組織_管理組織 */
  export const PmSalesReport_1_0_3 = PageId.PmSalesReport + '-Pm-103';

  /** 売上日報月報_売上日報月報(担当者別)_組織毎_担当者 */
  export const PmSalesReport_1_1_0 = PageId.PmSalesReport + '-Pm-110';

  /** 売上日報月報_売上日報月報(担当者別)_組織毎_得意先 */
  export const PmSalesReport_1_1_1 = PageId.PmSalesReport + '-Pm-111';

  /** 売上日報月報_売上日報月報(担当者別)_組織毎_担当者 - 組織 */
  export const PmSalesReport_1_1_2 = PageId.PmSalesReport + '-Pm-112';

  /** 売上日報月報_売上日報月報(担当者別)_組織毎_管理組織 */
  export const PmSalesReport_1_1_3 = PageId.PmSalesReport + '-Pm-113';

  /** 売上日報月報_売上日報月報(受注者別)_全組織_受注者 */
  export const PmSalesReport_2_0_0 = PageId.PmSalesReport + '-Pm-200';

  /** 売上日報月報_売上日報月報(受注者別)_全組織_得意先 */
  export const PmSalesReport_2_0_1 = PageId.PmSalesReport + '-Pm-201';

  /** 売上日報月報_売上日報月報(受注者別)_全組織_受注者 - 組織 */
  export const PmSalesReport_2_0_2 = PageId.PmSalesReport + '-Pm-202';

  /** 売上日報月報_売上日報月報(受注者別)_全組織_管理組織 */
  export const PmSalesReport_2_0_3 = PageId.PmSalesReport + '-Pm-203';

  /** 売上日報月報_売上日報月報(受注者別)_組織毎_受注者 */
  export const PmSalesReport_2_1_0 = PageId.PmSalesReport + '-Pm-210';

  /** 売上日報月報_売上日報月報(受注者別)_組織毎_得意先 */
  export const PmSalesReport_2_1_1 = PageId.PmSalesReport + '-Pm-211';

  /** 売上日報月報_売上日報月報(受注者別)_組織毎_受注者 - 組織 */
  export const PmSalesReport_2_1_2 = PageId.PmSalesReport + '-Pm-212';

  /** 売上日報月報_売上日報月報(受注者別)_組織毎_管理組織 */
  export const PmSalesReport_2_1_3 = PageId.PmSalesReport + '-Pm-213';

  /** 売上日報月報_売上日報月報(発行者別)_全組織_発行者 */
  export const PmSalesReport_3_0_0 = PageId.PmSalesReport + '-Pm-301';

  /** 売上日報月報_売上日報月報(発行者別)_全組織_得意先 */
  export const PmSalesReport_3_0_1 = PageId.PmSalesReport + '-Pm-302';

  /** 売上日報月報_売上日報月報(発行者別)_全組織_発行者 - 組織 */
  export const PmSalesReport_3_0_2 = PageId.PmSalesReport + '-Pm-303';

  /** 売上日報月報_売上日報月報(発行者別)_全組織_管理組織 */
  export const PmSalesReport_3_0_3 = PageId.PmSalesReport + '-Pm-304';

  /** 売上日報月報_売上日報月報(発行者別)_組織毎_発行者 */
  export const PmSalesReport_3_1_0 = PageId.PmSalesReport + '-Pm-311';

  /** 売上日報月報_売上日報月報(発行者別)_組織毎_得意先 */
  export const PmSalesReport_3_1_1 = PageId.PmSalesReport + '-Pm-312';

  /** 売上日報月報_売上日報月報(発行者別)_組織毎_発行者 - 組織 */
  export const PmSalesReport_3_1_2 = PageId.PmSalesReport + '-Pm-313';

  /** 売上日報月報_売上日報月報(発行者別)_組織毎_管理組織 */
  export const PmSalesReport_3_1_3 = PageId.PmSalesReport + '-Pm-314';

  /** 売上日報月報_売上日報月報(地区別)_全組織_地区 */
  export const PmSalesReport_4_0_0 = PageId.PmSalesReport + '-Pm-400';

  /** 売上日報月報_売上日報月報(地区別)_全組織_得意先 */
  export const PmSalesReport_4_0_1 = PageId.PmSalesReport + '-Pm-401';

  /** 売上日報月報_売上日報月報(地区別)_全組織_地区 - 組織 */
  export const PmSalesReport_4_0_2 = PageId.PmSalesReport + '-Pm-402';

  /** 売上日報月報_売上日報月報(地区別)_組織毎_地区 */
  export const PmSalesReport_4_1_0 = PageId.PmSalesReport + '-Pm-410';

  /** 売上日報月報_売上日報月報(地区別)_組織毎_得意先 */
  export const PmSalesReport_4_1_1 = PageId.PmSalesReport + '-Pm-411';

  /** 売上日報月報_売上日報月報(地区別)_組織毎_地区 - 組織 */
  export const PmSalesReport_4_1_2 = PageId.PmSalesReport + '-Pm-412';

  /** 売上日報月報_売上日報月報(業種別)_全組織_業種 */
  export const PmSalesReport_5_0_0 = PageId.PmSalesReport + '-Pm-500';

  /** 売上日報月報_売上日報月報(業種別)_全組織_得意先 */
  export const PmSalesReport_5_0_1 = PageId.PmSalesReport + '-Pm-501';

  /** 売上日報月報_売上日報月報(業種別)_全組織_業種 - 組織 */
  export const PmSalesReport_5_0_2 = PageId.PmSalesReport + '-Pm-502';

  /** 売上日報月報_売上日報月報(業種別)_組織毎_業種 */
  export const PmSalesReport_5_1_0 = PageId.PmSalesReport + '-Pm-510';

  /** 売上日報月報_売上日報月報(業種別)_組織毎_得意先 */
  export const PmSalesReport_5_1_1 = PageId.PmSalesReport + '-Pm-511';

  /** 売上日報月報_売上日報月報(業種別)_組織毎_業種 - 組織 */
  export const PmSalesReport_5_1_2 = PageId.PmSalesReport + '-Pm-512';

  /** 売上日報月報_売上日報月報(販売区分別)_全組織 */
  export const PmSalesReport_6_0 = PageId.PmSalesReport + '-Pm-60';

  /** 売上日報月報_売上日報月報(販売区分別)_組織毎 */
  export const PmSalesReport_6_1 = PageId.PmSalesReport + '-Pm-61';

}



// WEBPACK FOOTER //
// ./src/app/shared/screen/print-page-id-define.ts